import React from 'react';

export const AppContext = React.createContext({
  docsVersion: '',
  version: '',
  uploadArtifact: () => {},
  uploadAiArtifact: () => {},
  artifactProgress: 0,
  aiArtifactProgress: 0,
  globalSettings: {},
  redirect: {},
  updateRedirect: () => {}
});
